import { Input } from "@/components/ui/input";
import { OptionCard } from "./OptionCard";

const SIZES = [
  { key: "Small", hint: "One small room or a few repairs" },
  { key: "Medium", hint: "One large room or 2-3 rooms" },
  { key: "Large", hint: "Whole floor, basement or many rooms" },
];

export const SizeStep = ({ size, sqft, onSize, onSqft }) => (
  <div className="space-y-6">
    <div className="grid gap-3">
      {SIZES.map((s) => (
        <OptionCard key={s.key} title={s.key} hint={s.hint} selected={size === s.key} compact
          onClick={() => onSize(s.key)} testId={`size-option-${s.key.toLowerCase()}`} />
      ))}
    </div>
    <label className="block">
      <span className="text-sm font-semibold text-slate-700">Square feet (optional)</span>
      <div className="relative mt-2">
        <Input type="number" inputMode="numeric" min="1" value={sqft} onChange={(e) => onSqft(e.target.value)}
          placeholder="e.g. 350" data-testid="size-sqft-input"
          className="h-14 rounded-xl border border-slate-200 bg-white pr-16 shadow-soft text-[17px] focus-visible:ring-0 focus-visible:border-[color:var(--brand)]" />
        <span className="absolute right-4 top-1/2 -translate-y-1/2 text-sm text-slate-400">sq ft</span>
      </div>
    </label>
  </div>
);
